module.exports = __webpack_public_path__ + "static/media/IMG_4263.e7feae29.PNG";